import { Injectable } from '@angular/core';
// LIBS
import { BehaviorSubject, Observable } from 'rxjs';
// SERVICES
import { LocalStorageService } from '@services/storage/local-storage.service';
// MODELS
import { Permission } from '@models/permission/Permission';
import { Profile } from '@models/profile/Profile';
// CONST
import { STORAGE_KEYS } from '@constants/StorageKeys';

@Injectable({
  providedIn: 'root'
})
export class UserConfigurationService {
  private permissionsSubject: BehaviorSubject<Permission[]>;
  public permissions: Observable<Permission[]>;

  constructor(private storageService: LocalStorageService) {
    this.permissionsSubject = new BehaviorSubject<Permission[]>(this.getPermissions());
    this.permissions = this.permissionsSubject.asObservable();
  }

  setUp(profile:  Profile) {
    const { permissions } = profile;
    this.permissionsSubject.next(permissions);
    this.storageService.storeObject(STORAGE_KEYS.PERMISSIONS, permissions);
  }

  clear() {
    this.storageService.remove(STORAGE_KEYS.PERMISSIONS);
    this.permissionsSubject.next([]);
  }

  permissionsValue(): Permission[] {
    return this.permissionsSubject.value;
  }

  isLoggedIn(): boolean {
    return !!this.permissionsValue();
  }

  getPermissions(): Permission[] {
    return this.storageService.getObject(STORAGE_KEYS.PERMISSIONS) || [];
  }
}
